import { Toaster } from '@fluentui/react-components';
import { useMediaQuery } from '@/shared/hooks/use-media-query';

/** The app's single Fluent toaster (mutation outcomes, docs/plan/12-frontend.md §4). */
export const APP_TOASTER_ID = 'bf-toaster';

/** Under 768 px the shell has a bottom navigation bar (packages/ui app-bar): toasts sit above it. */
const PHONE = '(max-width: 767.98px)';
const ABOVE_BOTTOM_BAR = { vertical: 72 };

export function AppToaster() {
  const phone = useMediaQuery(PHONE);
  return (
    <Toaster
      toasterId={APP_TOASTER_ID}
      position="bottom-end"
      pauseOnHover
      pauseOnWindowBlur
      {...(phone ? { offset: ABOVE_BOTTOM_BAR } : {})}
    />
  );
}
